import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { canStartBrowserApplication } from '@resilience/config/production';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Application root was not found');

const safeTarget = canStartBrowserApplication(window.location.origin, import.meta.env);

createRoot(root).render(
  <StrictMode>
    {safeTarget ? (
      <App />
    ) : (
      <main role="alert">
        <h1>CRM is temporarily unavailable</h1>
        <p>The release configuration needs attention. Please contact your CRM administrator.</p>
      </main>
    )}
  </StrictMode>,
);
